<template>
  <div>
    <!--
    <b-card no-body >
      <b-card-body>
        <span>Programación de Fertilización</span>
      </b-card-body>
    </b-card>
    -->

    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col lg="2">
            <b-form-group label-for="filterInput" class="mb-0">
              <b-button variant="gradient-primary" size="sm" class="mr-1" @click="traerSubAreas">
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
              </b-button>
              <b-button variant="gradient-primary" size="sm" class="mr-1">
                <font-awesome-icon icon="fa-solid fa-plus" />
              </b-button>
              <b-button variant="gradient-primary" size="sm">
                <span v-if="loading2"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
                <span v-else>
                  <font-awesome-icon icon="fa-solid fa-file-excel" />
                </span>


              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-table hover responsive class="position-relative" :per-page="perPage" :current-page="currentPage" :items="items"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        :filter="filter" :filter-included-fields="filterOn" @filtered="cPaginacion" :busy="loading" show-empty
        empty-text="No se encontraron datos en esta tabla.">
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm" label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1">
          <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline :options="pageOptions" />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
            prev-class="prev-item" next-class="next-item" class="mb-0">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>

    <b-modal id="modal-prevent-closing" ref="my-modal"
      title="Ingresar nueva programación - Semana 23 - Del 06 de Junio al 12 de Junio" ok-title="Registrar"
      cancel-title="Cancelar" cancel-variant="outline-secondary" size="xl" centered :ok-disabled="false" no-close-on-esc
      no-close-on-backdrop @show="resetModal" @hidden="resetModal" @ok="handleOk">
      <validation-observer ref="formularioFertilizacion" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="handleSubmit">
          <b-row>
            <b-col lg="2">
              <b-form-group label="Semana" label-for="semana">
                <validation-provider #default="{ errors }" name="Semana" vid="semana" rules="required">
                  <b-form-input id="semana" v-model="semana" :state="errors.length > 0 ? false : null" name="semana" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="5">
              <b-form-group label="Empresa" label-for="empresa">
                <validation-provider #default="{ errors }" name="Empresa" vid="empresa" rules="required">
                  <v-select id="empresa" v-model="empresa" :options="empresas" placeholder="Seleccionar empresa..." />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="5">
              <b-form-group label="Cultivo" label-for="cultivo">
                <validation-provider #default="{ errors }" name="Cultivo" vid="cultivo" rules="required">
                  <v-select id="cultivo" v-model="cultivo" :options="cultivos" placeholder="Seleccionar cultivo..." />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group label="Fundo" label-for="fundo">
                <validation-provider #default="{ errors }" name="Fundo" vid="fundo" rules="required">
                  <v-select id="fundo" v-model="fundo" :options="fundos" placeholder="Seleccionar fundo..." />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Etapa" label-for="etapa">
                <validation-provider #default="{ errors }" name="Etapa" vid="etapa" rules="required">
                  <v-select id="etapa" v-model="etapa" :options="etapas" placeholder="Seleccionar etapa..." />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Campo" label-for="campo">
                <validation-provider #default="{ errors }" name="Campo" vid="campo" rules="required">
                  <v-select id="campo" v-model="campo" :options="campos" placeholder="Seleccionar campo..." />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Turno" label-for="turno">
                <validation-provider #default="{ errors }" name="Turno" vid="turno" rules="required">
                  <v-select id="turno" v-model="turno" :options="turnos" placeholder="Seleccionar turno..."
                    @input="seleccionarTurno" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group label="Variedad" label-for="variedad">
                <validation-provider #default="{ errors }" name="Variedad" vid="variedad" rules="required">
                  <b-form-input id="variedad" v-model="variedad" :state="errors.length > 0 ? false : null"
                    name="variedad" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Lote" label-for="lote">
                <validation-provider #default="{ errors }" name="Lote" vid="lote" rules="required">
                  <b-form-input id="lote" v-model="lote" :state="errors.length > 0 ? false : null" name="lote" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Valvula" label-for="valvula">
                <validation-provider #default="{ errors }" name="Valvula" vid="valvula" rules="required">
                  <b-form-input id="valvula" v-model="valvula" :state="errors.length > 0 ? false : null" name="valvula" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Área" label-for="area">
                <validation-provider #default="{ errors }" name="Área" vid="area" rules="required">
                  <b-form-input id="area" v-model="area" :state="errors.length > 0 ? false : null" name="area" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group label="Código" label-for="codigo">
                <validation-provider #default="{ errors }" name="Código" vid="codigo" rules="required">
                  <b-form-input id="codigo" v-model="codigo" :state="errors.length > 0 ? false : null" name="codigo" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="." label-for="btn_inst">
                <b-button variant="warning" class="btn-icon" block @click="buscarProducto">
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Producto" label-for="producto">
                <validation-provider #default="{ errors }" name="Producto" vid="producto" rules="required">
                  <b-form-input id="producto" v-model="producto" :state="errors.length > 0 ? false : null"
                    name="producto" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Grupo" label-for="grupo">
                <validation-provider #default="{ errors }" name="Grupo" vid="grupo" rules="required">
                  <b-form-input id="grupo" v-model="grupo" :state="errors.length > 0 ? false : null" name="grupo" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Und. Medida" label-for="uni_med">
                <validation-provider #default="{ errors }" name="Und. Medida" vid="uni_med" rules="required">
                  <b-form-input id="uni_med" v-model="uni_med" :state="errors.length > 0 ? false : null" name="uni_med" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="1">
              <b-form-group label="Días" label-for="dias">
                <validation-provider #default="{ errors }" name="Días" vid="dias" rules="required">
                  <b-form-input id="dias" v-model="dias" :state="errors.length > 0 ? false : null" name="dias" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Kg/Ha/Día" label-for="kg_ha_dia">
                <validation-provider #default="{ errors }" name="Kg/Ha/Día" vid="kg_ha_dia" rules="required">
                  <b-form-input id="kg_ha_dia" v-model="kg_ha_dia" :state="errors.length > 0 ? false : null"
                    name="kg_ha_dia" @input="calcularMaxDia" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Total Max. Día" label-for="total_max_dia">
                <validation-provider #default="{ errors }" name="Total Max. Día" vid="total_max_dia" rules="required">
                  <b-form-input id="total_max_dia" v-model="total_max_dia" :state="errors.length > 0 ? false : null"
                    name="total_max_dia" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Lunes" label-for="lunes">
                <validation-provider #default="{ errors }" name="Lunes" vid="lunes" rules="required">
                  <b-form-input id="lunes" v-model="lunes" :state="errors.length > 0 ? false : null" name="lunes" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Martes" label-for="martes">
                <validation-provider #default="{ errors }" name="Martes" vid="martes" rules="required">
                  <b-form-input id="martes" v-model="martes" :state="errors.length > 0 ? false : null" name="martes" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Miércoles" label-for="miercoles">
                <validation-provider #default="{ errors }" name="Miércoles" vid="miercoles" rules="required">
                  <b-form-input id="miercoles" v-model="miercoles" :state="errors.length > 0 ? false : null"
                    name="miercoles" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Jueves" label-for="jueves">
                <validation-provider #default="{ errors }" name="Jueves" vid="jueves" rules="required">
                  <b-form-input id="jueves" v-model="jueves" :state="errors.length > 0 ? false : null" name="jueves" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Viernes" label-for="viernes">
                <validation-provider #default="{ errors }" name="Viernes" vid="viernes" rules="required">
                  <b-form-input id="viernes" v-model="viernes" :state="errors.length > 0 ? false : null" name="viernes" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Sábado" label-for="sabado">
                <validation-provider #default="{ errors }" name="Sábado" vid="sabado" rules="required">
                  <b-form-input id="sabado" v-model="sabado" :state="errors.length > 0 ? false : null" name="sabado" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="1">
              <b-form-group label="Domingo" label-for="domingo">
                <validation-provider #default="{ errors }" name="Domingo" vid="domingo" rules="required">
                  <b-form-input id="domingo" v-model="domingo" :state="errors.length > 0 ? false : null" name="domingo" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="2">
              <b-form-group label="Indicador" label-for="indicador">
                <validation-provider #default="{ errors }" name="Indicador" vid="indicador" rules="required">
                  <b-form-input id="indicador" v-model="indicador" :state="errors.length > 0 ? false : null"
                    name="indicador" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../../libs/axios'
import vSelect from 'vue-select'
import { BBadge, BButton, BCard, BCardBody, BForm, BFormGroup, BFormInput, BFormSelect, BModal, BPagination, BSpinner, BTable, BRow, BCol, BDropdownDivider, } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
  },
  data: () => ({
    loading: false,
    loading2: false,
    items: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: false,
    sortDirection: 'asc',
    filter: null,
    filterOn: [],
    fields: [
      {
        key: 'id',
        label: 'id',
        sortable: true,
      },
      {
        key: 'cod',
        label: 'código',
        sortable: true,
      },
      {
        key: 'nombre',
        label: 'nombre',
        sortable: true,
      },
      {
        key: 'descripcion',
        label: 'descripción',
        sortable: true,
      },
      {
        key: 'pag_areas',
        label: 'Área',
        sortable: true,
      },
      {
        key: 'estado',
        label: 'estado',
        sortable: true,
      },
    ],
    status: [
      {
        0: 'Activo',
        1: 'Inactivo',
      },
      {
        0: 'light-success',
        1: 'light-danger',
      }
    ],

    // validation rules
    required,
  }),
  computed: {},
  mounted() {
    this.traerSubAreas();
    localize("es");
  },
  methods: {
    traerSubAreas() {
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/pagricolas/subareas/'
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            yo.items = response.data;
            yo.totalRows = yo.items.length
          }

        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading = false
        })
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    handleSubmit() {
      this.$refs.formularioFertilizacion.validate().then(success => {
        if (success) {
          this.items.push(
            {
              "id": this.items.length + 1,
              "semana": 23,
              "cultivo": this.cultivo,
              "etapa_fen": 'PRODUCTIVA',
              "empresa": this.empresa,
              "fundo": this.fundo,
              "etapa": this.etapa,
              "campo": this.campo,
              "turno": this.turno,
              "variedad": this.variedad,
              "lote": this.lote,
              "valvula": this.valvula,
              "area": this.area,
              "cod_producto": this.codigo,
              "producto": this.producto,
              "grupo_producto": this.grupo,
              "subgrupo_producto": null,
              "und_medida": this.uni_med,
              "dias": this.dias,
              "kg_ha_dia": this.kg_ha_dia,
              "total_max_dia": this.total_max_dia,
              "lun": this.lunes,
              "mar": this.martes,
              "mie": this.miercoles,
              "jue": this.jueves,
              "vie": this.viernes,
              "sab": this.sabado,
              "dom": this.domingo,
              "estado": "0"
            })
          // Hide the modal manually
          this.$nextTick(() => {
            this.$refs['my-modal'].toggle('#toggle-btn')
          })
        }
      })
    },

    resetModal() {
      this.name = ''
      this.nameState = null

      this.cultivo = null
      this.empresa = null
      this.fundo = null
      this.etapa = null
      this.campo = null
      this.turno = null
      this.variedad = null
      this.lote = null
      this.valvula = null
      this.area = null
      this.codigo = null
      this.producto = null
      this.grupo = null
      this.uni_med = null
      this.dias = null
      this.kg_ha_dia = null
      this.total_max_dia = "0.0"
      this.lunes = "0.0"
      this.martes = "0.0"
      this.miercoles = "0.0"
      this.jueves = "0.0"
      this.viernes = "0.0"
      this.sabado = "0.0"
      this.domingo = "0.0"
      this.indicador = "0.0"
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    seleccionarTurno() {
      console.log(this.turno)
      if (this.turno === 'TURNO 1-A') {
        this.lote = '3005-3006-3007-3008'
        this.valvula = '04-03-02-01'
        this.variedad = 'BILOXI'
        this.area = '11.09'
      } else {
        this.lote = '3001-3002-3003-3004'
        this.valvula = '08-07-06-05'
        this.variedad = 'BILOXI'
        this.area = '11.32'
      }
    },

    buscarProducto() {
      if (this.codigo === '2510041') {
        this.producto = '4CROPS MICROMIX (I.AHIERRO 20,ZINC 35GL)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      } else if (this.codigo === '2510044') {
        this.producto = '4RESIST K (I.A FOSFITO POTASIO)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      }
    },

    calcularMaxDia() {
      const kg = this.kg_ha_dia
      const are = this.area
      this.total_max_dia = (kg * are).toLocaleString('es-PE', { maximumFractionDigits: 2 })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
